import React from "react";
import aboutUsBanner from "../../assets/images/aboutUsBanner.png";
export default function AboutUsBanner() {
  return (
    <div className="about-us-banner">
      <img src={aboutUsBanner} className="banner" alt="About Us Banner" />
    </div>
  );
}
